import * as T from '@/types'

////////////////////////////////////////////////////////////////
// types
////////////////////////////////////////////////////////////////

export type FileId = T.EntityId

////////////////////////////////////////////////////////////////
// file (JSON:API Deserialized)
////////////////////////////////////////////////////////////////

export interface File extends T.Entity {
    case: T.Case
    createdAt: T.IsoTimestamp
    creditor: T.Creditor
    description: string
    downloadedAt: T.IsoTimestamp
    fileDownloadLogs?: FileDownloadLog[]
    fileName: string
    fileUrl: string
    id: T.EntityId
    mimeType: string
    name: string
    source: T.Source
    tags?: T.Tag[]
    type: string
    updatedAt: T.IsoTimestamp
}

////////////////////////////////////////////////////////////////
// download log
////////////////////////////////////////////////////////////////

export interface FileDownloadLog {
    id: string
    fileId: FileId
    downloadMethod: FileDownloadMethod
    userId: T.UserId
    downloadPath: string
    downloadedAt: T.IsoTimestamp
    createdAt: T.IsoTimestamp
    updatedAt: T.IsoTimestamp
}

export enum FileDownloadMethod {
    SFTP = 'sftp',
    USER = 'user',
    ACCESS_CODE = 'accesscode',
}
